import { Link } from "react-router-dom";
import { Linkedin, Instagram, Mail, ArrowUpRight } from "lucide-react";
import { LINKS, IMAGES } from "../data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 overflow-hidden">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-24">
        <div className="md:col-span-5">
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Connect</p>
          <div className="flex flex-col gap-3">
            <a
              href={`mailto:${LINKS.email}`}
              data-testid="footer-email-link"
              className="inline-flex items-center gap-3 text-paper hover:text-brand transition-colors duration-300 font-body"
            >
              <Mail size={16} className="text-brand" /> {LINKS.email}
            </a>
            <a
              href={LINKS.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              className="inline-flex items-center gap-3 text-paper hover:text-brand transition-colors duration-300 font-body"
            >
              <Linkedin size={16} className="text-brand" /> linkedin.com/in/gurpreetpaulusa
            </a>
            <a
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="inline-flex items-center gap-3 text-paper hover:text-brand transition-colors duration-300 font-body"
            >
              <Instagram size={16} className="text-brand" /> @thirstea_usa_
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Explore</p>
          <div className="flex flex-col gap-3">
            {[
              { to: "/journey", label: "The Journey" },
              { to: "/book", label: "The Book" },
              { to: "/awards", label: "Awards" },
              { to: "/franchise", label: "Franchise" },
              { to: "/press", label: "Press Kit" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-white/60 hover:text-brand transition-colors duration-300 font-body text-sm"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Ventures</p>
          <a
            href={LINKS.thirstea}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-thirstea-link"
            className="inline-flex items-center gap-4 text-paper hover:text-brand transition-colors duration-300 font-body"
          >
            <img
              src={IMAGES.thirsteaLogo}
              alt="ThirsTea USA logo"
              data-testid="footer-thirstea-logo"
              className="w-16 h-auto"
            />
            ThirsTea USA <ArrowUpRight size={14} />
          </a>
          <p className="text-white/40 text-sm mt-3 leading-relaxed font-body">
            Premium boba tea, slushies & iced tea. Franchising across America and beyond.
          </p>
        </div>
      </div>

      <div className="select-none" data-testid="footer-massive-name">
        <h2 className="font-display font-medium tracking-tighter leading-[0.85] text-[13vw] text-white/[0.07] whitespace-nowrap">
          Gurpreet Paul<span className="text-brand">.</span>
        </h2>
      </div>

      <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-[12px] text-white/35 font-body">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} Gurpreet Paul. All rights reserved.</span>
        <span>Founder · CEO · Author · Franchise Builder</span>
      </div>
    </div>
  </footer>
);
